import React, { useState, useRef, useEffect } from "react";
import {
  ColumnDirective,
  ColumnsDirective,
  GridComponent,
  Inject,
  Page,
  Sort,
  Filter,
  ColumnMenu,
} from "@syncfusion/ej2-react-grids";
import dataService from "../../service/data/DataService";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const sortSettings = {
  allowSorting: true,
};

const columnMenuItems = ["SortAscending", "SortDescending", "Filter"];

const pageSettings = { pageSize: 18 };

const filterSettings = {
  type: "CheckBox",
};

const dateTemplate = (props) => {
  if (props.created_date) {
    const date = props.created_date.toDate();
    return date.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
  }
  return "";
};

const Partners = () => {
  const [userId, setUserId] = useState(null);
  const [currentUserData, setCurrentUserData] = useState(null);
  const [partners, setPartners] = useState([]);
  const gridRef = useRef(null);

  useEffect(() => {
    const auth = getAuth();

    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        const selectedUserId = sessionStorage.getItem("userId");
        setUserId(selectedUserId);
        const fetchPartners = async () => {
          try {
            const partnersData = await dataService.getAllPartners();
            console.log("partners", partnersData);
            setPartners(partnersData);
          } catch (error) {
            console.error("Error fetching partners: ", error);
          }
        };

        fetchPartners();
      } else {
        setCurrentUserData(null);
        console.log("No user is logged in");
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (userId) {
      fetchData();
    }
  }, [userId]);

  const fetchData = async () => {
    const userData = await dataService.getUserProfile("users", userId);
    if (userData) {
      setCurrentUserData(userData);
    }
  };

  return (
    <>
      <div className={`flex max-w-full flex-col gap-5 px-2.5 py-[15px]`}>
        <div className="flex items-center gap-2 pt-2 text-xs text-darkslateblue">
          <span className="font-medium text-blue-500">Partners</span>
        </div>
      </div>
      <header className=" flex w-full flex-row items-center  justify-between self-stretch rounded-3xs px-2.5 text-left text-xs text-darkslateblue">
        <div>
          <h2 className="mb-1 text-sm font-bold uppercase text-blue-500">
            List of Partners
          </h2>
        </div>
      </header>
      <div className="mt-3 w-full rounded-3xs px-2.5  text-left text-xs text-darkslateblue">
        <GridComponent
          ref={gridRef}
          dataSource={partners.filter((item) => item.is_deleted !== true)}
          allowSorting={true}
          sortSettings={sortSettings}
          filterSettings={filterSettings}
          allowFiltering={true}
          allowPaging={true}
          pageSettings={pageSettings}
          showColumnMenu={true}
          columnMenuItems={columnMenuItems}
          height="70vh"
        >
          <ColumnsDirective>
            <ColumnDirective
              field="id"
              headerText="Partner ID"
              isPrimaryKey={true}
              visible={false}
            />
            <ColumnDirective
              field="name_of_org"
              headerText="Name of Organization"
              width="200"
              validationRules={{ required: true }}
            />
            <ColumnDirective
              field="email"
              headerText="Email"
              width="180"
              validationRules={{ required: true }}
            />
            <ColumnDirective
              field="created_date"
              headerText="Date Created"
              width="120"
              template={dateTemplate}
            />
          </ColumnsDirective>
          <Inject services={[Page, Sort, Filter, ColumnMenu]} />
        </GridComponent>
      </div>
    </>
  );
};

export default Partners;
